import { region } from '../models/constraint.model';

const regionOptions: { value: region; label: string }[] = [
  { value: 'Europe', label: 'policy.region.Europe' },
  { value: 'Northern America', label: 'policy.region.NorthernAmerica' },
  { value: 'Latin America', label: 'policy.region.LatinAmerica' },
  { value: 'Africa', label: 'policy.region.Africa' },
  { value: 'Asia', label: 'policy.region.Asia' },
  { value: 'Oceania', label: 'policy.region.Oceania' }
];

export { regionOptions };
